import Immutable from 'seamless-immutable';
import _ from 'lodash';
import {
  createRequestState,
  setRequestStateFinish,
  setRequestStateInProgress
} from '../../../../utils/reducerHalpers/requestState';

const INIT_STATE = 'INIT_STATE';
const REQUEST_IN_PROGRESS = 'REQUEST_IN_PROGRESS';
const REQUEST_FINISHED = 'REQUEST_FINISHED';
const SEND_REQUEST = 'SEND_REQUEST';

const createActionName = (reducerName, name) => `app/${reducerName}/${name}`;
export const getState = (state, reducerName) => _.get(state, reducerName);

const createReducer = name => {
  function stateDefault() {
    return {
      ...createRequestState()
    };
  }

  const initialState = Immutable(stateDefault());
  return function reduce(state = initialState, action = {}) {
    switch (action.type) {
      case createActionName(name, INIT_STATE):
        return Immutable(stateDefault());
      case createActionName(name, REQUEST_IN_PROGRESS):
        return setRequestStateInProgress(state);
      case createActionName(name, REQUEST_FINISHED):
        return setRequestStateFinish(
          state,
          action.payload.codeResponse,
          action.payload.hasSuccess
        );
      case createActionName(name, SEND_REQUEST):
        return state;
      default:
        return state;
    }
  };
};

export function createReduceObject(combineName, reducerName) {
  const reduceObject = {};
  reduceObject[reducerName] = createReducer(`${combineName}.${reducerName}`);
  return reduceObject;
}

// ACTIONS CREATOR
export const initState = parentName => ({
  type: createActionName(parentName, INIT_STATE)
});
export const requestInProcess = parentName => ({
  type: createActionName(parentName, REQUEST_IN_PROGRESS)
});
export const requestFinished = (parentName, codeResponse, hasSuccess) => ({
  type: createActionName(parentName, REQUEST_FINISHED),
  payload: { codeResponse, hasSuccess }
});
export const sendRequest = (parentName, payload) => ({
  type: createActionName(parentName, SEND_REQUEST),
  payload
});

// SELECTORS
export const selectRequestState = (state, parentName) =>
  _.get(getState(state, parentName), 'requestState');



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/tasks/common/reducers/execCreateForm.js